module.exports = __webpack_public_path__ + "img/12_22.4767d482.png";